// 百度地图获取城市名称的方法
import axios from 'axios'
import store from '@/store/index'
import AMapLoader from '@amap/amap-jsapi-loader'

export function getLocationA(AMap) {
  return new Promise(function(resolve, reject) {
    AMap.plugin('AMap.Geolocation', function() {
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 1000
      })
      geolocation.getCurrentPosition(function(status, result) {
        if (status === 'complete') {
          onComplete(result)
        } else {
          onError(result)
        }
      })

      function onComplete(data) {
        let res = data.position
        resolve({
          code: 1,
          longitude: res.lng,
          latitude: res.lat
        })
      }

      function onError(data) {
        resolve('获取定位失败.')
        console.log('获取定位失败', data)
        // 定位出错
      }
    })
  })
}
export function initMap() {
  return new Promise(function(resolve, reject) {
    AMapLoader.load({
      key: 'c9665982bbdb6ea723bcd60b2cf15687', // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.Geolocation'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      AMapUI: {
        // 是否加载 AMapUI，缺省不加载
        version: '1.1', // AMapUI 缺省 1.1
        plugins: [] // 需要加载的 AMapUI ui插件
      },
      Loca: {
        // 是否加载 Loca， 缺省不加载
        version: '1.3.2' // Loca 版本，缺省 1.3.2
      }
    })
      .then(AMap => {
        resolve(AMap)
      })
      .catch(e => {
        console.log(e)
      })
  })
}
export function getCurrentCityName(longitude, latitude) {
  return new Promise(function(resolve, reject) {
    store.commit('showLoading')
    axios({
      baseURL: 'https://api.tengzone.com/baidu/map',
      url: `/geocoder/v2/?ak=jyFGZNv9j8EBtSGa351HMIGKp7MxZPPW&location=${latitude},${longitude}&output=json&coordtype=gcj02ll`,
      method: 'POST'
    }).then(res => {
      store.commit('hideLoading')
      let adcode = res.data.result.addressComponent.adcode
      resolve(adcode)
    })
  })
}
